<script setup lang="ts">
import { computed } from 'vue';
import { AnalyticsClickBehaviour } from '@pkg/config/misc/analyticsClickBehaviour';
import { AppStore } from '@pkg/sanity-utils/constants/appstore';
import {
  useAppStoresConfig,
  type AppStoreDownloadTarget,
} from '../../../frontend/appStores';
import AppleAppStore from './AppleAppStore.vue';
import GooglePlay from './GooglePlay.vue';
import HuaweiAppGallery from './HuaweiAppGallery.vue';

interface Props {
  appStore: AppStoreDownloadTarget;
  link?: string;
  buttonColor?: string;
}

const props = defineProps<Props>();

const appStores = useAppStoresConfig();

const component = computed(() => {
  switch (props.appStore) {
    case AppStore.APPLE_APP_STORE:
      return AppleAppStore;
    case AppStore.GOOGLE_PLAY_STORE:
      return GooglePlay;
    case AppStore.HUAWEI_APP_GALLERY:
      return HuaweiAppGallery;
    default:
      return null;
  }
});

const boundProps = computed(() => {
  const { appStore, link, ...rest } = props;

  return {
    ...rest,
    link: link ?? appStores.value?.[appStore] ?? '',
  };
});
</script>

<template>
  <component
    :is="component"
    v-if="component"
    v-bind="boundProps"
    class="amp-auto-track"
    :data-analytics-click-behaviour="AnalyticsClickBehaviour.DownloadApp"
  />
</template>
